import CITATION_TEMPLATES from '../data/citations.json';

// Utility to generate realistic mock citations based on jurisdiction and year
export function generateMockCitations({ jurisdiction = '', year = '' } = {}) {
  const j = (jurisdiction || '').toLowerCase()
  const y = year || String(new Date().getFullYear())
  const prevY = parseInt(y) - 1
  const oldY = parseInt(y) - 5
  const shortOldY = String(oldY).slice(2)

  const citations = []
  const push = (c) => citations.push({ text: c, id: Math.random().toString(36).slice(2, 9) })

  const replacePlaceholders = (template) => {
    return template
      .replace('{year}', y)
      .replace('{prevYear}', prevY)
      .replace('{oldYear}', oldY)
      .replace('{shortOldYear}', shortOldY)
      .replace(/\{rand(\d+)_(\d+)\}/g, (_, min, range) => Math.floor(parseInt(min) + Math.random() * parseInt(range)));
  }

  let templates = CITATION_TEMPLATES.general;

  if (j.includes('us') || j.includes('united states') || j === 'us') {
    templates = CITATION_TEMPLATES.us;
  } else if (j.includes('uk') || j.includes('united kingdom') || j === 'uk') {
    templates = CITATION_TEMPLATES.uk;
  } else if (j.includes('eu') || j.includes('european') || j === 'eu') {
    templates = CITATION_TEMPLATES.eu;
  } else if (j.includes('np') || j.includes('nepal') || j === 'np') {
    templates = CITATION_TEMPLATES.nepal;
  }

  templates.forEach(t => push(replacePlaceholders(t)));

  // Shuffle and return 2-4 citations
  for (let i = citations.length - 1; i > 0; i--) {
    const r = Math.floor(Math.random() * (i + 1))
      ;[citations[i], citations[r]] = [citations[r], citations[i]]
  }

  return citations.slice(0, Math.floor(2 + Math.random() * 3))
}
